module.exports = __webpack_public_path__ + "img/lv3.0c9d870e.png";